import { listRoutes } from './routes';
export default [listRoutes];